import cx from 'classnames';
import React, {useEffect, useRef} from 'react';
import {Text} from '@priority-software/priority-style-react';
import styles from '../../styles/ToDoListConent.module.scss';

export const StatusListItem = ({isFocused, isLast, value, handleSelect}) => {
    const itemRef = useRef();

    useEffect(() => {
        const statusEl = itemRef.current;
        if (isFocused && statusEl) {
            (statusEl as HTMLDivElement).scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
            });
        }
    }, [isFocused]);

    return (
        <div ref={itemRef}>
            <Text
                skin="label-1"
                componentClasses={cx(styles.statusListItem, {
                    [styles.focusedItem]: isFocused,
                    [styles.borderBottom]: !isLast
                })}
                textColor="primary-700"
                onClick={() => handleSelect(value)}
            >
                {value}
            </Text>
        </div>
    );
};
